import {
  EmptyState,
  Button,
  PlusIcon,
  SavedRepliesIcon,
} from '@buffer-mono/popcorn'

export const SavedReplyEmptyState = ({
  setOpenForm,
}: {
  setOpenForm: (open: boolean) => void
}): JSX.Element => {
  return (
    <EmptyState>
      <EmptyState.Icon>
        <SavedRepliesIcon />
      </EmptyState.Icon>

      <EmptyState.Description>
        Save information you share often to quickly insert it to your replies
      </EmptyState.Description>
      <EmptyState.Actions>
        <Button variant="primary" onClick={(): void => setOpenForm(true)}>
          <PlusIcon />
          New Saved Reply
        </Button>
      </EmptyState.Actions>
    </EmptyState>
  )
}
